export class FormulaList {


Formula:  string;
}
